"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksConnectRefundData = exports.QuickbooksConnectCreateRefundData = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const refund_transport_1 = require("../invoice/refund-transport");
exports.QuickbooksConnectCreateRefundData = typebox_1.Type.Object({
    refund: refund_transport_1.RefundTransport,
    type: typebox_1.Type.Union([typebox_1.Type.Literal('receivable'), typebox_1.Type.Literal('payable')]),
    // in this case it's the payable or receivable ID
    invoiceID: typebox_1.Type.String({ format: 'uuid' }),
});
exports.QuickbooksConnectRefundData = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    invoiceID: typebox_1.Type.String({ format: 'uuid' }),
    type: typebox_1.Type.Union([typebox_1.Type.Literal('receivable'), typebox_1.Type.Literal('payable')]),
    platform: typebox_1.Type.Union([typebox_1.Type.Literal('sap'), typebox_1.Type.Literal('wayste')]),
    quickbooksSyncToken: typebox_1.Type.Optional(typebox_1.Type.String()),
    quickbooksID: typebox_1.Type.Optional(typebox_1.Type.String()),
    refundDate: typebox_1.Type.String({ format: 'date-time' }),
    amount: typebox_1.Type.Integer(),
    paymentMethod: common_1.PaymentMethod,
    refundIdentifier: typebox_1.Type.Optional(typebox_1.Type.String()),
    payoutIdentifier: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdated: typebox_1.Type.String({ format: 'date-time' }),
    lastSynced: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    lastSyncError: typebox_1.Type.Optional(typebox_1.Type.String()),
    retrySyncAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
});
//# sourceMappingURL=refund-data.js.map